export var ThemedEventCateogry;
(function (ThemedEventCateogry) {
    ThemedEventCateogry[ThemedEventCateogry["Event"] = 888] = "Event";
})(ThemedEventCateogry || (ThemedEventCateogry = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/ThemedEventCategory.ts
// module id = 943
// module chunks = 3